import React, { ReactNode, FC ,useMemo, useEffect,useState } from 'react';
import classNames from 'classnames/bind';
import FallbackableImage from '../../molecules/FallbackableImage';
import Text from '../../atoms/Text';
import { VariantType } from '../../atoms/Text/Text';
// import ProductLabel from '../../molecules/ProductLabel';
import PriceRevealPLP from '../../../components/common/ListingPage/priceRevealPLP/PriceRevealPLP';
import styles from './index.pcss';
import { redirect } from '../../utils/cartUtils';
import { sendEventGA } from '../../utils/gaEvents';
import { addCustomerType, isExclusiveDatePast } from '../../../utils/products';
import {
  getProductItemPDP,
  luxeGtmProductClick,
  segmentDatalayerPushData,
  segmentEventPush
} from '../../../modules/ga/GTMdatalayer';
import { connect } from 'react-redux';
import { getCurrentStore } from '../../selectors/metaData';
import { getVariant } from '../../organism/ABFeature/Feature';
import Button from '../../atoms/button';
import Icon from '../../../refresh/atoms/Icon';
import getWishlistPriceDropData from '../../../refresh/utils/wishlistPriceDropUtils';
import { signInCheck } from '../../../components/common/CheckUserStatus';
import luxeList from '../../constants/luxeScreenType';
import properties from '../../../modules/ajio-util/properties';
import AggregatedRatingTag from '../../atoms/AggregatedRatingTag';
import { Feature, Variant } from '../../../refresh/organism/ABFeature';
import { getEnableRating, getEnableRatingLabelCart, getGiftWithProductEnable, getGiftWithProductConfig, getRushDeliveryFlag, getPriorityDeliveryPhase2Flag, getPriorityDeliverySLPTagsConfig, getPriorityDeliveryConfig } from '../../../refresh/selectors/featureFlagsSelector';
import { isCatalogNameInFirebaseStore } from '../../../utils/common';
import { deliveryMethod as DELIVERY_METHOD } from '../../../refresh/constants/ordersData.constants';
import { getStoresForHidingMRP, getStreetFlags } from '../../../refresh/selectors/featureFlagsSelector';
import { STREET_STORE } from '../../../constants/constant';
import { catalogIdToStoreName } from '../../../utils';
import { setLandingPageScrollCookies } from '../../../utils/banner';
import { isMarketing } from '../../../utils/pdp';
import { replaceWithJioCDN } from '../../../../src/utils/imageHandling';
import { handleSegmentEventsForJioAds, handleWindowUnloadForSegment } from '../../../fleek/utils/feedGaUtils';
import { fireOsmosClickTracker } from '../../../../src/utils/osmosPlpImpressionUtils';
import { getPlaAdsClientID } from '../../../refresh/selectors/featureFlagsSelector';
import AjioWalletConstants from '../../../utils/AjioWalletConstants';
import { formatPrice } from '../../utils/priceUtils';
import { getPriceRevealSaleDuration } from '../../../components/common/PriceRevealPLPBanner/priceRevealUtil';

const ajioUrl = properties.getProperty('parentUrl');
const luxeUrl = properties.getProperty('luxeURL');
const streetURL = properties.getProperty('streetURL');
const imageBaseUrl = properties.getProperty("imageBaseUrl") ;
const textVariants: VariantType[] = ['T2', 'T2'];
// TODO: update `Product` after understanding data
type Product = {
  id: string;
  mainImage: string;
  imageHeight: number;
  imageWidth: number;
  description: string;
  brand: string;
  model: string;
  currentPrice: number;
  actualPrice: number;
  discount: number;
  descriptionPageURL: string;
  uclid?: string;
};
type Size = 'xl' | 'lg' | 'md' | 'sm';
interface ProductCardProps {
  size?: Size;
  product: Product;
  newTabOpener?: boolean;
  emphasizeDiscount?: boolean;
  renderAddOns?: (product: Product) => ReactNode;
  containerClass?: string;
  disabled?: boolean;
  showDiscount?: boolean;
  isPriceReveal?: boolean;
  isPriceRevealDuringSale?: boolean;
  luxe?: boolean | undefined;
  pageType?: string | undefined;
  eventPush?:(A: Record<string, string>) => void;
  eventPushObj?:object | undefined;
  index:number;
  pageList?:string;
  currentStore?:string;
  isWishlisted?:boolean | undefined;
  addToWishlistApi?:(code: any, productColor: any) => void;
  similarProductsVariant:number;
  recentlyViewed: Array<object>;
  isRecentView? :boolean;
  enableRating? : boolean;
  enableRatingLabelCart : boolean;
  widgetTitle?:string;
  storesForHidingMRP:  Array<object>;
  showDynamicWidgetMoreLink?: boolean;
  ctaText?: string;
  isDynamicProductList?: boolean;
  viewShowMoreProducts: () => void;
  dynamicProductWidgetRedirection: (url : string) => void;
  heading:string | undefined;
  rowNumber:Number;
  banners:any;
  curatedId?: string;
  enableGiftWithProduct: boolean;
  giftWithProductConfig: object;
  exitIntent?: boolean;
  isFromHomePage?: boolean | undefined;
  isCrossSell?: boolean | undefined;
  baseProduct?: object;
  isFromAjiogramLandingPage?: boolean;
  isPlpOnLandingWidget?: boolean;
  isPlpOnLandingEnabled?: boolean;
  plpOnLandingProductConfig?: object;
  priorityDeliveryConfig?: object;
  priorityDeliveryTagsBucket?: object;
  ajiogramInterventionsConfig?: object;
  plpOnLandingHeading?: string;
  isFromPDP?: boolean;
  isSearchPage?: boolean;
  widgetPosition?: number | string;
  isJioAdsWidget?: boolean;
  feedLogic?: string;
  parentProductObj?: any;
  isComingSoonEnabled?: boolean;
  uclid?: string;
  isInfiniteScroll?: boolean;
  handleWidgetClickSegment?: () => void;
}
const ProductCard: FC<ProductCardProps> = (props: ProductCardProps) => {
  const {
    pageType = '',
    product,
    size,
    renderAddOns,
    newTabOpener,
    containerClass,
    emphasizeDiscount,
    disabled,
    showDiscount,
    isPriceReveal,
    isPriceRevealDuringSale,
    luxe,eventPush,eventPushObj,
    index,
    pageList,
    isWishlistHalfcard,
    currentStore,
    productWidgetCard = false,
    addToWishlistApi,
    similarProductsVariant,
    recentlyViewed,
    isRecentView,
    enableRatingLabelCart,
    enableRating = false,
    widgetTitle,
    storesForHidingMRP,
    isStreetStore,
    showDynamicWidgetMoreLink,
    ctaText,
    isDynamicProductList,
    viewShowMoreProducts,
    dynamicProductWidgetRedirection,
    banners,
    curatedId,
    heading,
    rowNumber,
    enableGiftWithProduct,
    giftWithProductConfig,
    exitIntent,
    isFromHomePage = false,
    baseProduct,
    isCrossSell,
    isFromAjiogramLandingPage = false,
    enableRushDelivery,
    enablePriorityDeliveryPhase2,
    priorityDeliverySLPTagsConfig,
    isPlpOnLandingWidget = false,
    isPlpOnLandingEnabled = false,
    plpOnLandingProductConfig = {},
    priorityDeliveryConfig = {},
    priorityDeliveryTagsBucket = {},
    ajiogramInterventionsConfig = {},
    plpOnLandingHeading = '',
    isFromPDP = false,
    isSearchPage = false,
    widgetPosition = '',
    isJioAdsWidget = false,
    feedLogic ='',
    parentProductObj,
    isComingSoonEnabled = false,
    store = '',
    flags = {},
    priceRevealMetaInfo = {},
    isInfiniteScroll = false,
    handleWidgetClickSegment = () => {}
  } = props;
  const { plp : {screenType ='', screenName=''}, similarTo : {widgetName = ''} } = luxeList;
  const {
    plpConfig: {
      tagContent: { logo = '', text = '', backgroundColor = '', textColor = '' } = {},
      enableIntervention = false
    } = {}
  } = ajiogramInterventionsConfig;

  const {
    id,
    mainImage,
    imageHeight,
    imageWidth,
    description,
    brand,
    model,
    currentPrice,
    catalogName,
    actualPrice,
    discount,
    descriptionPageURL,
    offerPrice,
    isGiftWithPurchase = false,
    priceValue,
    code,
    brickName,
    productTag,
    productTagEngineValue,
    deliverySlaTag,
    productSellingFastTag,
    productPriceLabel,
    isExclusive,
    productColor,
    productCategory,
    productSize,
    averageRating,
    numUserRatings,
    segmentId = '',
    experimentId = '',
    deliveryMethod='',
    slaDeliveryTag=''
  } = product;

  const priceRevealState = getPriceRevealSaleDuration(flags, 'mobile', priceRevealMetaInfo, store);

const repositionWishlistButtons = () => {
  const containers = document.querySelectorAll<HTMLElement>("#plp_wishlist");

  containers.forEach((container) => {
    const parent = container.closest("#home_plp"); // main card container
    const img = parent?.querySelector<HTMLImageElement>("a > img");

    if (!img) return;

    const height = img.offsetHeight;
    if (!height) return; // skip if image not loaded yet

    const topPosition = luxe ? `${height - 20}px`: `${height - 40}px`;// adjust 40px = icon size

    Object.assign(container.style, {
      position: "absolute",
      top: topPosition,
      right: "10px", // tweak for spacing
      zIndex: "5",
    });

    // ensure parent is positioning context
    if (parent) {
      (parent as HTMLElement).style.position = "relative";
    }
  });
};
  useEffect(() => {
    const observerOptions = {
      threshold: 0.7 // Adjust this threshold as needed
    };
    const itemElement = document.getElementById(`jio-ads-${product?.code}`);
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        const segmentProductObj = {
          product_position: index,
          product_brand: product?.brand,
          product_id: product?.code,
          product_name: product?.description,
          product_mrp: product?.currentPrice,
          product_list_price: Number(product?.actualPricex) || 0,
          product_segment: product?.segmentName,
          product_vertical: product?.verticalName,
          product_brick: product?.brickName,
          product_tag: '',
          product_rating: product?.averageRating,
          product_wishlisted_count: '',
          catalog_id: product?.catalogName,
          similar_product_icon_available_flag: false,
          ad_flag: true,
          ad_id: feedLogic,
          priority_delivery_edd: '',
          client_id: parentProductObj.client_id,
          ad_source: parentProductObj.ad_source
        };
        delete parentProductObj.client_id;
        delete parentProductObj.ad_source;
        // console.log("🚀 ~ ProductCard ~ segmentProductObj:", segmentProductObj)
        handleSegmentEventsForJioAds('jioAdsBundleData', 'jioAdsBundleDataImpressions',segmentProductObj, 'ajio', 'pdp screen', 'pdp screen', parentProductObj, product?.uclid || '', index)
      }
    }, observerOptions);

    repositionWishlistButtons();

    window.addEventListener("resize", repositionWishlistButtons);
    if (itemElement) {
      observer.observe(itemElement);
    }

    window.addEventListener('beforeunload', () => {
      handleWindowUnloadForSegment('jioAdsBundleData');
    });

    // Clean up the observer when the component unmounts
    return () => {
      window.removeEventListener("resize", repositionWishlistButtons);
      window.removeEventListener(
        'beforeunload',
        handleWindowUnloadForSegment('jioAdsBundleData')
      );
      observer.disconnect();
    };
  }, []);

   useEffect(() => {
    repositionWishlistButtons();
  }, [props.product]);

  const { PLP_BUCKET = {} } = priorityDeliverySLPTagsConfig ? priorityDeliverySLPTagsConfig : {};
  let storeForRedirect = 0;
  if(isRecentView && recentlyViewed?.length > 0 ) {
     const recentlyViewedItemIndex = recentlyViewed?.findIndex(el => el.id == productColor);
     storeForRedirect = recentlyViewedItemIndex > -1 ? recentlyViewed[recentlyViewedItemIndex].store : 0;
  }
  const session_id =
    typeof sessionStorage !== 'undefined' ? sessionStorage.getItem('sessionId') : '';
  const enablePlpIntervention =
    enableIntervention &&
    String(currentStore).toLowerCase() === 'ajio' &&
    String(catalogName).toLowerCase() === 'ajiogram';
 
  const discountSplit = discount?.split(" ");
  const prodDiscount = discountSplit?.length > 0 ? discountSplit[0] : 0;
  const { priceReveal, value, giftAvailable = false } = offerPrice || {};
  const cx = classNames.bind(styles);
  const containerCls = cx(
    showDynamicWidgetMoreLink ? 'dynamic-widget' : '',
    isPlpOnLandingEnabled ? 'plp-on-landing-prdt' : '',
    showDynamicWidgetMoreLink && luxe ? 'luxe-article-container' : '',
    pageType === 'pdp-msite' && luxe
      ? 'luxe-container'
      : pageType === 'pdp-msite'
      ? 'pdp-container'
      : 'container',
    {
      productWidgetCard: productWidgetCard && luxe
    },
    {
      [`${
        luxe && pageType !== 'pdp-msite'
          ? 'luxe'
          : luxe && pageType === 'pdp-msite'
          ? 'pdpluxe'
          : pageType === 'pdp-msite'
          ? 'pdp'
          : ''
      }container-${size}`]: true,
      [containerClass]: !!containerClass
    }
  );
  const imgCls = cx(
    {
      [`${
        pageType === 'pdp-msite' && luxe
          ? 'pdpluxe'
          : pageType === 'pdp-msite'
          ? 'pdp'
          : luxe
          ? 'luxe'
          : ''
      }img-${size}`]: true,
      'img-disabled': !!disabled,
      ajiogram: isFromAjiogramLandingPage,
      widget_coverage: isFromPDP
    },
    {
      productWidgetCardImage: (productWidgetCard || isFromHomePage) && luxe
    }
  );
  const priceCls = cx(luxe ? (pageType !== 'pdp-msite' ? 'luxePrice' : 'pdpluxeprice') : pageType === 'pdp-msite' ? 'pdpPrice' :'price', {
    [`price-${size}`]: true
  },{
    'jioAds-price' : isJioAdsWidget
  });
  const checkIsWishlisted = (productCode) => {
    const username = signInCheck(true);
    const wishlistData = JSON.parse(localStorage.getItem('productWishlistStatusData'));
    if(!wishlistData || !username) return false;
    const userWishlistData = wishlistData[username];
    if(!userWishlistData) return false;
    const { codes = [] } = userWishlistData;
    if(codes.length === 0) return false;
    return codes.includes(productCode);
  }
  const wishlistIconCommonStyles = {
    fontWeight: 'bold',
    zIndex: 1,
    color: checkIsWishlisted(productColor) && !luxe ? '#f97676' : '#202020'
  };
  const getDiscountFontSize: (cardSize: Size) => string = cardSize => {
    let fontSize;
    switch (cardSize) {
      case 'sm':
        fontSize = 'T1';
        break;
      case 'md':
        fontSize = 'T2';
        break;
      default:
        fontSize = 'T2';
        break;
    }
    return fontSize;
  };
  const redirectFn = redirect(isRecentView ? (storeForRedirect == 2 ?  streetURL : (storeForRedirect == 1 ? luxeUrl : ajioUrl)) +  descriptionPageURL : descriptionPageURL) ;
  const product_tag =
    isComingSoonEnabled && productTag.toLowerCase() === 'coming soon'
      ? productTag
      : isExclusiveDatePast(isExclusive)
      ? 'EXCLUSIVE'
      : productTag?.toLowerCase() !== 'exclusive'
      ? productTag
      : '';
  const hideMRP = isCatalogNameInFirebaseStore(storesForHidingMRP, catalogName)
  const luxeMargin = luxe ? { margin: '0' } : {};

  // NOTE: FOR PLP ON LANDING PAGE
  const {
    showDesc = false,
    showOffer = false,
    showPrice = false,
    showProductTag = false,
    showUrgencyTags = false,
    showWishlist = false,
    showProductRating = false
  } = plpOnLandingProductConfig;
  const shouldShowDescription = isPlpOnLandingEnabled ? showDesc : true;
  const shouldShowOffer = isPlpOnLandingEnabled ? showOffer : true;
  const shouldShowProductTag = isPlpOnLandingEnabled ? showUrgencyTags : true;
  const shouldShowUrgencyTag = isPlpOnLandingEnabled ? showProductTag : true;
  const shouldShowRating = isPlpOnLandingEnabled ? showProductRating : true;
  const shouldShowPriceDetails = isPlpOnLandingEnabled ? showPrice : true;
  const shouldShowWishlistButton = isPlpOnLandingEnabled ? showWishlist : true;

  return (
    <article
      key={id}
      data-key={id}
      className={containerCls}
      style={(luxe && isFromHomePage) ? { marginRight: '8px'} : {}}
      id={
        widgetTitle
          ? exitIntent
            ? `exitIntent_product_${index}`
            : `product_${widgetTitle}_${index}`
          : `product_${index}`
      }
       >
      {showDynamicWidgetMoreLink ?
        <div className={cx('view-more-main-container', luxe ? 'view-more-main-container-luxe' : '')} onClick={() => viewShowMoreProducts()}>
          <div
            className={cx(
              'show-view-more',
              !luxe ? 'rounded-corner' : 'luxe-container',
              isFromAjiogramLandingPage ? 'ajiogram' : ''
            )}
            style={{
              width: luxe ? '128px' : '143px',
              height: luxe ? '162px' : '18rem',
              ...luxeMargin
            }}
          >
            <div className={cx('view-more-container', isFromPDP ? 'widget_coverage' : '')}>
              <p className={cx('ctaText')}>{ctaText}</p>
              <img alt="Right arrow" src={`${imageBaseUrl}/static/img/show-view-more-arrow.svg`}/>
            </div>
          </div>
        </div>
      : 
      <div id="home_plp" data-code={code}>
      <a
        aria-label={`${isExclusive ? 'Exclusive' : ''} ${brand}, ${description}, ${actualPrice ? (actualPrice === currentPrice ? `Price ${currentPrice}` : `Discount Price is ${currentPrice} and Actual Price is ${actualPrice}`) : `Price ${currentPrice},`} ${enableRating && averageRating && numUserRatings ?  `${averageRating} star rating & ${numUserRatings} reviews,` :'' } ${prodDiscount ? `${prodDiscount} off`: ''} ${shouldShowUrgencyTag && productSellingFastTag ? 'Selling Fast': ''}"`}
        tabIndex={0}
        className={cx('pdp-link',true ? 'pos-relative' : '')}
        onClick={(e) => {
          e.preventDefault();
          if(isJioAdsWidget){
            const resolvedWidgetPosition =
              widgetPosition !== '' && widgetPosition !== null && widgetPosition !== undefined ? widgetPosition : 0;
            const segmentProductObj = {
              product_position:index,
              product_brand: product?.brand,
              product_id: product?.code,
              product_name: product?.description,
              product_mrp: product?.currentPrice,
              product_list_price: Number(product?.actualPricex) || 0,
              product_segment: product?.segmentName,
              product_vertical: product?.verticalName,
              product_brick: product?.brickName,
              product_tag: '',
              product_rating: product?.averageRating,
              product_wishlisted_count: '',
              catalog_id: product?.catalogName,
              similar_product_icon_available_flag: false,
              ad_flag: true,
              ad_id: feedLogic,
              priority_delivery_edd: '',
              client_id: parentProductObj?.client_id,
              ad_source: parentProductObj?.ad_source,
              uclid: product?.uclid,
              sku_id: product?.code || '',
              seller_id: product?.sellerId || '',
              scl_id: product?.sclid || '',
            };
            const { ad_source = '', client_id, ...restParentProductObj } = parentProductObj || {};
            
            segmentDatalayerPushData({
            event: 'Product Clicked',
            ecommerce: { items: [{ ...segmentProductObj }] },
            impression_source: segmentProductObj?.ad_source === 'osmos' || product?.uclid ? 'osmos_pdp_widget' : 'jioads_pdp_widget',
            impression_type: segmentProductObj?.ad_source === 'osmos' || product?.uclid ? 'osmos_pdp_widget' : 'jioads_pdp_widget',
            ...restParentProductObj,
            ...segmentProductObj
            });                

            segmentEventPush({
              event:'Widget Clicked', 
              screen_name: 'pdp screen',
              widget_id:  ad_source === 'osmos' ? 'osmos_pdp_widget' : 'jioads_pdp_widget',
              widget_name: ad_source === 'osmos' ? 'osmos_pdp_widget' : 'jioads_pdp_widget',
              widget_position: resolvedWidgetPosition,
              widget_type: ad_source === 'osmos' ? 'osmos_pdp_widget' : 'jioads_pdp_widget',
              ad_source: ad_source,
              client_id: client_id || getPlaAdsClientID(window?.__PRELOADED_STATE__) || '',
              ...restParentProductObj
            });

            // Fire OSMOS click tracker for sponsored widget products
            fireOsmosClickTracker(product?.uclid, 'PDP');
          }

          if(pageType === 'pdpExitIntent' || pageType === 'pdp' || pageType === 'pdp-msite'){
            const isExternalLink = isMarketing(window.location.href);
            if(isExternalLink && !luxe)
              {
                sessionStorage.setItem('exitIntent', 'true');
              }
          }

          if(!isJioAdsWidget){
          eventPush && eventPush({ 
            eventName: isCrossSell ? 'view_item_list_cross' : productWidgetCard ? 'view_item_list': 'widget_clicks',
            event_category:'widget interactions',
            event_action: 'widget clicks',
            ...(averageRating && numUserRatings && { dimension46: `${averageRating}|${numUserRatings}` }),
            ...eventPushObj 
          });
        }
          
          

          let listValue = pageType? similarProductsVariant && pageType =='plp' ? screenName + ' - ' + widgetName : pageList : 'bag screen';
            if (isDynamicProductList) {
              listValue =
                banners.widgetLevel.toLowerCase() === 'user'
                  ? `user_level_${banners?.feedLogic}_${heading}_${rowNumber}`
                  : `dynamic_${banners?.feedLogic}_${heading}_${rowNumber}`;
            }

          let gwpDimension = '';
          if (enableGiftWithProduct && giftAvailable) {
            gwpDimension = 'GetFreebies';
          }

          !isPlpOnLandingEnabled &&
            !isFromHomePage &&
            !isCrossSell &&
            luxeGtmProductClick({
            name:description,
            id:(code.length > 9 ? code.substring(0,9) : code),
            price:priceValue,
            brand,
            position: id,
            category:productCategory,
            product_size:productSize,
            product_color:productColor?productColor.split('_')[1]:"",
            product_trade_discount:discount,
            product_brick:brickName,
            product_tag:getVariant('enable_urgency_driver_pdp') ? productTagEngineValue : product_tag,
            list:listValue,
            store_type:currentStore,
            pageType: isSearchPage && isDynamicProductList ? 'search screen' : pageType ? similarProductsVariant && pageType =='plp' ? screenName : pageType ==='bag screen' ? 'bag screen' : 'pdp screen' : 'bag screen',
            pageName: isSearchPage && isDynamicProductList ? 'search screen' : pageType ? similarProductsVariant && pageType =='plp' ? screenName : pageType ==='bag screen' ? 'bag screen' : 'pdp screen' : 'bag screen',
            sourceStore: catalogIdToStoreName(catalogName),
            containsLuxe: true,
            productTagEngineValue: pageType === 'pdp' && getVariant('enable_urgency_driver_pdp') ? productTagEngineValue : '',
            productPriceLabel: pageType === 'pdp' && getVariant('enable_urgency_driver_pdp') ? productPriceLabel : '',
            catalog: catalogName,
            segmentId: segmentId,
            experimentId: experimentId,
            offerName: gwpDimension,
            skuId: product?.firstSizeVariantCode || ''
          })
          if (isPlpOnLandingEnabled) {
            luxeGtmProductClick({
              name: description,
              id: (code.length > 9 ? code.substring(0,9) : code),
              price: priceValue,
              brand,
              position: id,
              category: productCategory,
              product_size: productSize,
              product_color: productColor?productColor.split('_')[1]:"",
              product_trade_discount: discount,
              product_brick: brickName,
              product_tag: product_tag || productTagEngineValue,
              list: plpOnLandingHeading
                ? `endless_plp_${plpOnLandingHeading}`
                : 'endless_plp_widget_landing',
              impression_source: isInfiniteScroll ? 'endless_plp_widget_landing' : 'limited_plp_widget_landing',
              impression_type: 'Widget',
              store_type: currentStore,
              pageType: 'home landing screen',
              pageName: 'home landing screen',
              sourceStore: catalogIdToStoreName(catalogName),
              containsLuxe: luxe,
              productTagEngineValue: productTagEngineValue || product_tag,
              productPriceLabel: productPriceLabel,
              catalog: catalogName,
              segmentId: segmentId,
              experimentId: experimentId,
              offerName: gwpDimension,
              skuId: product?.firstSizeVariantCode || ''
            })
            handleWidgetClickSegment();
          }
          setLandingPageScrollCookies('MSITE');
          if(isDynamicProductList) {
            const url = addCustomerType(isRecentView ? (storeForRedirect == 2 ?  streetURL : (storeForRedirect == 1 ? luxeUrl : ajioUrl)) +  descriptionPageURL : descriptionPageURL);
            dynamicProductWidgetRedirection(url);
          } else {
            redirectFn();
          }
          sendEventGA({
            eventCategory: 'Page Interaction',
            eventAction: 'link click: pagelinks-1',
            eventLabel: brand
          });
          window.location.href = isDynamicProductList 
      ? 'javascript:void(0);'
      : addCustomerType(isRecentView 
        ? (storeForRedirect == 2 ? streetURL : (storeForRedirect == 1 ? luxeUrl : ajioUrl)) + descriptionPageURL
        : descriptionPageURL);

        }}
        target={newTabOpener ? '_blank' : '_self'}
        rel={newTabOpener ? 'noopener noreferrer' : ''}
        
      >
        {
          isComingSoonEnabled && product_tag && (
            <div
            className={cx('product-tag','wishlist-coming-soon-tag')}
            aria-label={product_tag}
          >
            {product_tag}
          </div>
          )
        }
        <FallbackableImage
          src={replaceWithJioCDN(mainImage)}
          alt={description}
          imageCls={imgCls}
          customErroredImgCls={cx('img-load-errored')}
          ariaHidden={true}
          isPlpOnLandingWidget={isPlpOnLandingEnabled}
          htmlLoading={index < 4 ? 'eager' : 'lazy'}
          fetchPriority={index < 4 ? 'high' : 'auto'}
          decoding={index < 4 ? 'sync' : 'async'}
        />   
        {shouldShowUrgencyTag && (product_tag || productTagEngineValue) && (
          <div
            className={cx('product-tag', (product_tag || productTagEngineValue) === 'NEW' && 'new-tag')}
            aria-label={product_tag || productTagEngineValue}
          >
            {product_tag || productTagEngineValue}
          </div>
        )}
        {shouldShowUrgencyTag && enablePlpIntervention && (
          <div className={cx('intervention-tag')} style={{ backgroundColor: backgroundColor }}>
            {' '}
            <img src={logo} alt="ajiogram tag" />
            <div style={{ color: textColor }} className={cx('text')}>
              {text}
            </div>
          </div>
        )}
        <header
          id="brand"
          className={luxe ? (pageType !== 'pdp-msite' ? cx('brand-title') : cx('brand-header')) : cx('ajio-header')}
        >
          <div className={cx('brand-name-heading')}>
            <Text
              variant="T2"
              color={luxe ? 'Light_Black' : isJioAdsWidget ? 'Dark_Grey' : 'Black'}
              weight="bold"
              textTransform={luxe ? 'is-uppercase' : 'none'}
              customClass={
                pageType === 'pdp-msite'
                  ? cx('brand-name')
                  : cx(!isJioAdsWidget  && 'brand-name-product-widget', isFromAjiogramLandingPage ? 'ajiogram' : '')
              }
            >
              {brand}
            </Text>
          </div>
          {/* <ProductLabel title={brand} description={model} withNoWrap textVariants={textVariants} /> */}
        </header>
          {(!(productWidgetCard && isPriceReveal) || isFromPDP) && shouldShowDescription && (
            <div className={cx(pageType === 'pdp-msite' && !luxe ? 'pdp-similar-description' : '', isJioAdsWidget && 'pdp-jio-ads')}>
              <Text
                variant={luxe ? 'T1' : 'T2'}
                color={
                  isFromAjiogramLandingPage ? 'Grey_White' : luxe ? 'Light_Black' : 'Dark_Grey'
                }
                textTransform="is-capitalized"
                customClass={cx(
                  pageType === 'pdp-msite'
                    ? luxe
                      ? 'pdpluxe-description-title'
                      : 'pdp-description-title'
                    : 'description-title'
                )}
                role="heading"
                ariaLevel={3}
                tabIndex={0}
                weight={isJioAdsWidget ? "bold" : 'regular'}
              >
                {description}
              </Text>
            </div>
          )}
          {((enableRating && averageRating && !luxe && enableRatingLabelCart) ||
            (pageType === 'pdpExitIntent' && averageRating && enableRating) || (enableRating && isJioAdsWidget && averageRating)) &&
            shouldShowRating && (
            <AggregatedRatingTag
              ratingValue={averageRating}
              totalRatingCount={numUserRatings}
              customClass={'rating-label-msite-cart-halfcard'}
              backGroundColour={averageRating < 3 ? 'red' : 'green'}
              isFromPDP={isFromPDP && !isSearchPage}
              luxe={luxe}
            />
          )}

          {!(isPriceReveal && isPriceRevealDuringSale) && shouldShowPriceDetails? (
            <div id="price_detail" className={priceCls} 
            tabIndex={0}
            aria-label={`${actualPrice? `the final price after discount is ${actualPrice}`:''} ,${enableRating && averageRating && numUserRatings ?  `${averageRating} star rating & ${numUserRatings} reviews` :'' }, ${currentPrice ? `offer price is ${currentPrice}` : ''} , ${prodDiscount ? `${prodDiscount} off`: ''}`}
            >
              <Text
                variant={'T1'}
                color={isFromAjiogramLandingPage ? 'White' : luxe ? 'Light_Black' : 'Nero'}
                weight={luxe ? 'regular' : 'bold'}
                ariaHidden={true}
              >
                {currentPrice}
              </Text>
              {!!actualPrice &&  actualPrice!==currentPrice && hideMRP && (
                <Text
                  variant={'T1'}
                  color={isFromAjiogramLandingPage ? 'Grey_White' : luxe ? 'Light_Charcoal' : 'Dark_Grey'}
                  weight={luxe ? 'regular' : 'bold'}
                  customClass={luxe&&pageType==="pdp-msite"?cx('product-price'):''}
                  ariaHidden={true}
                >
                  {actualPrice}
                </Text>
              )}
              {!!discount && showDiscount && actualPrice!==currentPrice && hideMRP && (
                <Text
                  variant={'T1'}
                  color={isJioAdsWidget ? 'Nero'
                     : isFromAjiogramLandingPage ? 'Fleek_Green' : emphasizeDiscount ? (luxe ? 'Nero' : 'Jade') : 'Nero'}
                  weight="bold"
                  ariaHidden={true}
                >
                  {prodDiscount +" OFF"}
                </Text>
              )} 
            </div>
          ) : null}
            {shouldShowOffer && offerPrice && !priceRevealState && (
              <div className={cx('offer_price', 'msite')}>
                <img
                  src={`${imageBaseUrl}/static/img/percentage.svg`}
                  alt="Offer icon"
                  className={cx(
                    'offer-icon',
                    isPlpOnLandingEnabled ? 'plp_landing-page__offer_icon' : ''
                  )}
                />
                <div>Offer Price : {AjioWalletConstants.AW_RUPEE_SYMBOL}
                {formatPrice(offerPrice?.displayformattedValue)}
                </div>
              </div>
            )}
        {enableGiftWithProduct && (isWishlistHalfcard ? isGiftWithPurchase : giftAvailable) && (
          <div className={isWishlistHalfcard ? cx('gwp-container-wishlist') : cx('gwp-container')}>
            <img className={cx('gwp-icon')} alt="Gift Wrap Icon" src={`${imageBaseUrl}/static/img/${luxe ? 'GWP-luxe.svg' : 'GWP.svg'}`}/>
            <span className={luxe ? cx('gwp-text-luxe') : cx('gwp-text')}>{giftWithProductConfig.productWidgetTitle}</span>
          </div>
        )}
        {/* {isPriceReveal && ( */}
            <PriceRevealPLP
              isPriceRevealPDP={isPriceRevealDuringSale || (isWishlistHalfcard && isPriceReveal)}
              priceReveal={priceReveal}
              isPriceReveal={isPriceReveal}
              orignalPrice={priceValue || '00'}
              offerValue={value}
              priceRevealClass="pr-pdp"
              pageType={pageType}
              luxe={luxe}
              isWishlistHalfcard={isWishlistHalfcard}
              isPlpOnLandingWidget={isPlpOnLandingEnabled}
              hasLineBreak={ luxe ? true : false }
              isFromAjiogramLandingPage={isFromAjiogramLandingPage}
            />
          {/* )} */}
        {shouldShowProductTag && deliverySlaTag &&
          priorityDeliveryTagsBucket[`${deliverySlaTag}`] && (
            <div
              className={
                cx(isFromAjiogramLandingPage ? 'fleek-pd-tag-container' : 'pd-tag-container')
              }
            >
              <img
                className={cx('pd-tag-icon')}
                alt="Priority Delivery Tag Icon"
                src={
                  isFromAjiogramLandingPage
                    ? priorityDeliveryConfig?.PD2_TRUCK_ICON_AJIOGRAM
                    : priorityDeliveryConfig?.PD2_TRUCK_ICON
                }
                aria-hidden={true}
              />
              <span className={cx(isFromAjiogramLandingPage ? 'fleek-pd-tag-text' : 'pd-tag-text')} aria-label={`Delivery in ${priorityDeliveryTagsBucket[`${deliverySlaTag}`]}`}>
                {priorityDeliveryTagsBucket[`${deliverySlaTag}`]}
              </span>
            </div>
          )}
        {shouldShowUrgencyTag && productSellingFastTag && (
          <div className={cx('selling-fast-tag-container')}>
            <Text
              variant={luxe ? 'T1' : 'T2'}
              weight="bold"
              color={luxe ? 'Light_Black' : 'Salmon'}
            >
              {productSellingFastTag}
            </Text>
          </div>
        )}
        {renderAddOns && renderAddOns(product)}
      </a>
      
        {(((pageType == 'plp' || (shouldShowWishlistButton && showWishlist)) &&
          similarProductsVariant) ||
          pageType === 'pdpExitIntent') &&
          (!luxe || (shouldShowWishlistButton && showWishlist)) &&
          <div
              id="plp_wishlist"
              className={cx('wishilistContainerScroll', luxe ? 'luxeWishilistContainer' : '')}
            >
            <div className={cx("wishlistBack")}  onClick={e => {  
              e.preventDefault();
              e.stopPropagation();
               segmentEventPush({
                event: 'Product Wishlisted',
                event_category: 'add_to_whishlist',
                event_action: 'added sucessfully',
                products : [ {
                    ...getProductItemPDP(product, index)
                }],          
                screen_name: 'plp screen',                              
              });
              addToWishlistApi(code, productColor)
              }}
              role="button"
              tabIndex={0}
              aria-label={checkIsWishlisted(productColor) ? `Remove from wishlist ${description?.substring(0, 4)}` : `Add to wishlist ${description?.substring(0, 4)}`}
              >
              <Icon
                icon={
                  checkIsWishlisted(productColor) ? 'icon-Wishlist_Active' : 'icon-Wishlist'
                }
                styles={
                  shouldShowWishlistButton && showWishlist
                    ? {
                        fontSize: '1.8rem',
                        marginTop: '-1px',
                        marginLeft: '1px',
                        ...wishlistIconCommonStyles
                      }
                    : { fontSize: '2.1rem', ...wishlistIconCommonStyles }
                }
                ariaHidden={true}
              />
            </div>
          </div>
        }
      </div>
      }
      {
      (enableRushDelivery || enablePriorityDeliveryPhase2) &&       //RUSH badge and sls showcasing inRecommended products on PDP
        slaDeliveryTag &&
        PLP_BUCKET[`${slaDeliveryTag}`] &&
        (pageType === 'pdp-msite' || pageType === 'pdp') && (
          <div
            className={cx('priority-delivery-container')}
            style={{display:"flex"}}
          >
            <img
              className={cx("priority-delivery-icon")}
              alt={deliveryMethod === DELIVERY_METHOD.RUSH ? "Rush Icon" : "Priority Delivery Icon"}
              src={
                deliveryMethod === DELIVERY_METHOD.RUSH
                  ? replaceWithJioCDN(priorityDeliveryConfig?.RUSH_ICON)
                  : replaceWithJioCDN(priorityDeliveryConfig?.PD2_TRUCK_ICON)
              }
            />
            <span
              className={cx('priority-delivery-text')}
            >
              {PLP_BUCKET[`${slaDeliveryTag}`]}
            </span>
          </div>
        )}
    </article>
  );
};
ProductCard.defaultProps = {
  size: 'md',
  newTabOpener: false,
  emphasizeDiscount: true,
  showDiscount: true,
  isPriceReveal: false,
  isPriceRevealDuringSale: false
};
const mapStateToProps = (state, ownProps) => {
  const { isThemeEnableMsite } = getStreetFlags(state);
  const { sis, name } = state.metaData;

  return {
    flags: state?.flags || {},
    store: sis ? name : 'AJIO',
    currentStore:getCurrentStore(state),
    recentlyViewed : state?.recentlyViewed?.recent || [],
    enableRating : getEnableRating(state?.flags, state),
    enableRatingLabelCart : getEnableRatingLabelCart(state) === 'ON',
    storesForHidingMRP : getStoresForHidingMRP(state),
    isStreetStore: isThemeEnableMsite === 'ON' && getCurrentStore(state) === STREET_STORE,
    enableGiftWithProduct : getGiftWithProductEnable(state?.flags),
    giftWithProductConfig: getGiftWithProductConfig(state),
    enableRushDelivery: getRushDeliveryFlag(state),
    enablePriorityDeliveryPhase2: getPriorityDeliveryPhase2Flag(state.flags),
    priorityDeliveryConfig: getPriorityDeliveryConfig(state),
    priorityDeliverySLPTagsConfig: getPriorityDeliverySLPTagsConfig(state),
  }
}
export default connect(mapStateToProps,null)(ProductCard);